var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68182 15.0909C8.68182 11.3295 11.7386 8.27273 15.5 8.27273C16.6477 8.27273 17.7386 8.55682 18.6818 9.06818L20.3409 7.40909C18.9432 6.52273 17.2841 6 15.5 6C10.4773 6 6.40909 10.0682 6.40909 15.0909L3 15.0909L7.54545 19.6364L12.0909 15.0909L8.68182 15.0909ZM24.5909 15.0909L28 15.0909L23.4545 10.5455L18.9091 15.0909L22.3182 15.0909C22.3182 18.8523 19.2614 21.9091 15.5 21.9091C14.3523 21.9091 13.2614 21.625 12.3182 21.1136L10.6591 22.7727C12.0568 23.6591 13.7159 24.1818 15.5 24.1818C20.5227 24.1818 24.5909 20.1136 24.5909 15.0909Z",
    fill: "#50A954"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.da70912c614ee72d5424d15149b4009b.svg";
export { ForwardRef as ReactComponent };